import { createAction } from '@reduxjs/toolkit';
import {
  IRecordedInterviewAssessmentPayload,
  IRecordedInterviewEntry,
  IRecordedInterviewUpdateScoresPayload,
  IRecordedInterviewProcessingStatus,
  EventInfoStatus,
} from 'types';
import { CoreActionTypes, OfferUpdateActionTypes, RecordedInterviewActionTypes, VisaStatus } from './types';

export const updateVisaStatus = createAction<VisaStatus>(CoreActionTypes.UPDATE_VISA_STATUS);

export const createUpdateOfferFieldAction = createAction(
  CoreActionTypes.UPDATE_OFFER_FIELD,
  (fieldName: string, value: any, refValue?: any) => ({
    payload: { fieldName, value, refValue },
  }),
);

export const requestScoresRegeneration = createAction<{ videoId: string }>(
  '@@student/offer/REQUEST_SCORES_REGENERATION',
);
export const requestScoresRegenerationSuccess = createAction('@@student/offer/REQUEST_SCORES_REGENERATION_SUCCESS');
export const requestScoresRegenerationFailed = createAction<unknown>(
  '@@student/offer/REQUEST_SCORES_REGENERATION_FAILED',
);

export const assessRecordedInterview = createAction<{
  interviewHash: string;
  payload: IRecordedInterviewAssessmentPayload;
}>(RecordedInterviewActionTypes.RECORDED_INTERVIEW_ASSESSMENT);

export const assessRecordedInterviewSuccess = createAction<IRecordedInterviewAssessmentSuccessPayload>(
  RecordedInterviewActionTypes.RECORDED_INTERVIEW_ASSESSMENT_SUCCESS,
);

export const assessRecordedInterviewFailure = createAction<unknown>(
  RecordedInterviewActionTypes.RECORDED_INTERVIEW_ASSESSMENT_FAILURE,
);

export const recordedInterviewEditQuestionScore = createAction<{
  interviewHash: string;
  payload: IRecordedInterviewUpdateScoresPayload;
}>(RecordedInterviewActionTypes.RECORDED_INTERVIEW_EDIT_QUESTION_SCORE);

export const recordedInterviewEditQuestionScoreSuccess = createAction<IRecordedInterviewAssessmentSuccessPayload>(
  RecordedInterviewActionTypes.RECORDED_INTERVIEW_EDIT_QUESTION_SCORE_SUCCESS,
);

export const recordedInterviewEditQuestionScoreFailure = createAction<unknown>(
  RecordedInterviewActionTypes.RECORDED_INTERVIEW_EDIT_QUESTION_SCORE_FAILURE,
);

export type IRecordedInterviewAssessmentSuccessPayload = {
  interviewHash: string;
  interview: IRecordedInterviewEntry;
};

export const requestVideoProcessingStatus = createAction<{ videoId: string; interviewHash: string }>(
  RecordedInterviewActionTypes.REQUEST_VIDEO_PROCESSING_STATUS,
);

export const requestVideoProcessingStatusSuccess = createAction<IRecordedInterviewProcessingStatus>(
  RecordedInterviewActionTypes.REQUEST_VIDEO_PROCESSING_STATUS_SUCCESS,
);
export const requestVideoProcessingStatusFailed = createAction<unknown>(
  RecordedInterviewActionTypes.REQUEST_VIDEO_PROCESSING_STATUS_FAILED,
);

export type UpdateCalendlyInterviewStatusPayload = { infoStatus: EventInfoStatus };
export const updateCalendlyInterviewsInfoStatus = createAction<UpdateCalendlyInterviewStatusPayload>(
  OfferUpdateActionTypes.UPDATE_CALENDLY_INTERVIEW_INFO_STATUS,
);
